import GLightbox from 'glightbox';

const customLightboxHTML = `<div id="glightbox-body" class="glightbox-container">
    <div class="gloader visible"></div>
    <div class="goverlay bg-dark"></div>
    <div class="gcontainer">
    <div id="glightbox-slider" class="gslider"></div>
    <button class="gnext gbtn fill-neutral-400 absolute top-1/2 right-2 -translate-y-1/2" tabindex="0" aria-label="Next">{nextSVG}</button>
    <button class="gprev gbtn fill-neutral-400 absolute top-1/2 left-2 -translate-y-1/2" tabindex="1" aria-label="Previous">{prevSVG}</button>
    <button class="gclose gbtn fill-neutral-400 absolute top-2 right-2" tabindex="2" aria-label="Close">{closeSVG}</button>
</div>
</div>`;

let customSlideHTML = `<div class="gslide">
    <div class="gslide-inner-content">
        <div class="ginner-container">
            <div class="gslide-media">
            </div>
            <div class="gslide-description font-sans text-white">
                <div class="gdesc-inner py-5">
                    <h4 class="gslide-title"></h4>
                    <div class="gslide-desc font-light"></div>
                </div>
            </div>
        </div>
    </div>
</div>`;

const lightbox = GLightbox({
  selector: '.lightbox',
  touchNavigation: true,
  lightboxHTML: customLightboxHTML,
  slideHTML: customSlideHTML,
  skin: 'kilanka'
});